import createIcon from '../../createIcon';

/**
 * @component @name FormatLineSpacing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4yNSA3SDguNzVMNS4yNSAzLjVMMS43NSA3SDQuMjVWMTdIMS43NUw1LjI1IDIwLjVMOC43NSAxN0g2LjI1VjdaTTEwLjI1IDVWN0gyMi4yNVY1SDEwLjI1Wk0xMC4yNSAxOUgyMi4yNVYxN0gxMC4yNVYxOVpNMTAuMjUgMTNIMjIuMjVWMTFIMTAuMjVWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatLineSpacing = createIcon('FormatLineSpacing', [
  [
    'path',
    {
      d: 'M6.25 7H8.75L5.25 3.5L1.75 7H4.25V17H1.75L5.25 20.5L8.75 17H6.25V7ZM10.25 5V7H22.25V5H10.25ZM10.25 19H22.25V17H10.25V19ZM10.25 13H22.25V11H10.25V13Z',
      key: '38qi9z',
    },
  ],
]);

export default FormatLineSpacing;
